import React, { useState, useCallback } from "react";
import { Modal } from "react-bootstrap";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import GooglePlaces from "../../Models/GooglePlaces";
import "./Modal.css";
import "./LocationPickerDialog.css";

// "Pick on the map" for Identify (4.10.55, 2026-10-26): when the place isn't
// in the suggested list — a pub, a shop, a landmark further away — it's very
// likely on Google Maps. The map opens where the photo was taken; tapping a
// Google landmark or business looks up its name (the same details lookup as
// the map's "Add POI to Guide"), and "Use this name" names the place.
// Same look as LocationPickerDialog.
const MapPickDialog = ({ show, onHide, lat, lng, onPick }) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_KEY,
    language: "en",
  });
  const [picked, setPicked] = useState(null); // { name } | { loading } | { error }

  const onMapClick = useCallback((e) => {
    if (!e.placeId) return;
    e.stop(); // no Google info window
    setPicked({ loading: true });
    GooglePlaces.getMoreDetails((_id, result) => {
      setPicked(result && result.name ? { name: result.name } : { error: true });
    }, e.placeId);
  }, []);

  const center = { lat: Number(lat), lng: Number(lng) };
  return (
    <div className="modal">
      <Modal show={show} onHide={onHide} animation={false} dialogClassName="lpd-dialog" style={{ zIndex: 70000 }} centered>
        <Modal.Body style={{ padding: 0 }}>
          <div className="lpd-shell map-pick">
            <div className="lpd-header">
              <div className="lpd-header-icon">
                <FontAwesomeIcon icon={solid("map-location-dot")} />
              </div>
              <h2 className="lpd-title">Pick on the map</h2>
              <button className="lpd-close" onClick={onHide} aria-label="Close">
                <FontAwesomeIcon icon={solid("xmark")} />
              </button>
            </div>
            <span className="lpd-hint">The pin is where the photo was taken. Tap a landmark, restaurant or shop on the map to use its name.</span>
            <div className="lpd-map-wrap">
              {isLoaded ? (
                <GoogleMap
                  mapContainerClassName="lpd-map"
                  center={center}
                  zoom={17}
                  onClick={onMapClick}
                  options={{ streetViewControl: false, mapTypeControl: false, fullscreenControl: false, clickableIcons: true }}
                >
                  <Marker position={center} />
                </GoogleMap>
              ) : (
                <div className="lpd-map-loading">Loading map…</div>
              )}
            </div>
            <span className="lpd-coords map-pick-result">
              {picked?.loading ? "Looking it up…" : picked?.error ? "Couldn't get that place's name — try another." : picked?.name ? `Selected: ${picked.name}` : "Nothing selected yet."}
            </span>
            <div className="lpd-footer">
              <button className="lpd-btn lpd-btn-cancel" onClick={onHide}>Cancel</button>
              <button
                className="lpd-btn lpd-btn-action"
                disabled={!picked?.name}
                onClick={() => {
                  onPick(picked.name);
                  onHide();
                }}
              >
                Use this name
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default MapPickDialog;
